//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';
import {
  faFileDownload,
  faShareNodes,
  faHeart,
  faEllipsisVertical,
} from '@fortawesome/pro-regular-svg-icons';
import { faHeart as fasHeart } from '@fortawesome/pro-solid-svg-icons';
import productPageEventsMixin from '@motionelements/catalog/src/modules/product/mixins/product-page-events.mixin.js';
import productPreviewModeMixin from '@motionelements/product2025/src/mixins/product-preview-mode.mixin.js';
import { faMeSearchAi } from '@/assets/icons/me-font-icons-regular';

export default {
  name: 'SecondaryCtaButtons',
  mixins: [productPageEventsMixin, productPreviewModeMixin],
  props: {
    product: {
      type: Object,
      required: true,
    },
    schema: {
      type: Array,
      default: () => ['similar', 'sample', 'share', 'favorite'],
    },
  },
  data() {
    return {
      faMeSearchAi,
      faFileDownload,
      faShareNodes,
      faHeart,
      fasHeart,
      faEllipsisVertical,
      //
      productSampleDownloading: false,
      productFavoriteLoading: false,
    };
  },
  computed: {
    ...mapState({
      addedToday: state => state.favorites.addedToday.map(({ id }) => id),
    }),
    ...mapGetters({
      isSimilaritySearchEnabled: 'product/isSimilaritySearchEnabled',
      hasSample: 'product/hasSample',
    }),
    isProductFavorited() {
      return _.get(this.product, 'favorited', false) || this.addedToday.includes(_.get(this.product, 'id'));
    },
  },
  mounted() {
    this.$bus.$on('product-event-finished', this.handleProductEventFinished);
  },
  beforeDestroy() {
    this.$bus.$off('product-event-finished', this.handleProductEventFinished);
  },
  methods: {
    onClickSimilar() {
      this.emitProductEvent('product-similar-search', { product: this.product });
    },
    onClickDownloadSample() {
      this.productSampleDownloading = true;
      this.emitProductEvent('product-sample-download', { product: this.product });
    },
    onClickFavorite() {
      this.productFavoriteLoading = true;
      this.emitProductEvent('product-favorite', {
        product: this.product,
      });
    },
    //
    showShareModal() {
      this.$bvModal.show('share-product-modal');
    },
    handleProductEventFinished({ event }) {
      console.log('======== product event finished ', event);
      if (event === 'product-sample-download') {
        this.productSampleDownloading = false;
      }
      if (event === 'product-favorite') {
        this.productFavoriteLoading = false;
      }
    },
    showCtaMenu() {
      this.$store.commit('app/toggleOverlay', true);
      this.$store.commit('app/toggleCtaMobileMenu', true);
    },
  },
};
